import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

export const getDeviceId = () => {
  let id = localStorage.getItem("shabba_device_id");
  if (!id) {
    id = "dev_" + (crypto?.randomUUID?.() || Math.random().toString(36).slice(2) + Date.now());
    localStorage.setItem("shabba_device_id", id);
  }
  return id;
};

export const askQuestion = (payload) =>
  axios.post(`${API}/ask`, { ...payload, device_id: getDeviceId() }).then((r) => r.data);

export const getFeed = () => axios.get(`${API}/feed`).then((r) => r.data);

export const likeQuestion = (id) =>
  axios.post(`${API}/like/${id}`).then((r) => r.data);
export const adminDeleteQuestion = (id) =>
  axios.delete(`${API}/admin/feed/${id}`).then((r) => r.data);
export const adminClearFeed = () =>
  axios.delete(`${API}/admin/feed`).then((r) => r.data);
export const reportQuestion = (id, reason) =>
  axios.post(`${API}/report/${id}`, { reason }).then((r) => r.data);
export const adminPinQuestion = (id, pinned) =>
  axios.post(`${API}/admin/feed/${id}/pin?pinned=${pinned}`).then((r) => r.data);
export const adminHideQuestion = (id, hidden) =>
  axios.post(`${API}/admin/feed/${id}/hide?hidden=${hidden}`).then((r) => r.data);

export const generatePost = (topic, model) =>
  axios.post(`${API}/generate-post`, { topic, model }).then((r) => r.data);

export const getConfig = () => axios.get(`${API}/persona`).then((r) => r.data);

// Ratings
export const submitRating = (stars, comment) =>
  axios.post(`${API}/ratings`, { stars, comment, device_id: getDeviceId() }).then((r) => r.data);
export const getRatingSummary = () => axios.get(`${API}/ratings/summary`).then((r) => r.data);

// Sessions
export const getSessionOptions = () => axios.get(`${API}/sessions/options`).then((r) => r.data);
export const requestSession = (payload) =>
  axios.post(`${API}/sessions/request`, payload).then((r) => r.data);
export const paySession = (id) =>
  axios.post(`${API}/sessions/${id}/pay`, {}).then((r) => r.data);
export const getMySessions = () => axios.get(`${API}/sessions/mine`).then((r) => r.data);
export const getAdminSessions = () => axios.get(`${API}/admin/sessions`).then((r) => r.data);
export const setSessionLink = (id, payload) =>
  axios.post(`${API}/admin/sessions/${id}/link`, payload).then((r) => r.data);
export const adminConfirmSession = (id, payload) =>
  axios.post(`${API}/admin/sessions/${id}/confirm`, payload).then((r) => r.data);

export const getAvailability = () => axios.get(`${API}/availability`).then((r) => r.data);
export const adminGetAvailability = () => axios.get(`${API}/admin/availability`).then((r) => r.data);
export const adminAddAvailability = (start) =>
  axios.post(`${API}/admin/availability`, { start }).then((r) => r.data);
export const adminDeleteAvailability = (id) =>
  axios.delete(`${API}/admin/availability/${id}`).then((r) => r.data);

export const adminGetWeekly = () => axios.get(`${API}/admin/availability/weekly`).then((r) => r.data);
export const adminAddWeekly = (weekday, time) =>
  axios.post(`${API}/admin/availability/weekly`, { weekday, time }).then((r) => r.data);
export const adminDeleteWeekly = (id) =>
  axios.delete(`${API}/admin/availability/weekly/${id}`).then((r) => r.data);

export const cancelSubscription = () =>
  axios.post(`${API}/subscription/cancel`, {}).then((r) => r.data);
export const getEarnings = () => axios.get(`${API}/admin/earnings`).then((r) => r.data);

export const formatNaira = (n) => "₦" + Number(n || 0).toLocaleString("en-NG");

export const getHistory = () => axios.get(`${API}/my/history`).then((r) => r.data);

// Auth
export const registerUser = (payload) =>
  axios.post(`${API}/auth/register`, payload).then((r) => r.data);
export const loginUser = (payload) =>
  axios.post(`${API}/auth/login`, payload).then((r) => r.data);
export const logoutUser = () => axios.post(`${API}/auth/logout`).then((r) => r.data);
export const fetchMe = () => axios.get(`${API}/auth/me`).then((r) => r.data);
export const googleSession = (sessionId) =>
  axios.post(`${API}/auth/google/session`, {}, { headers: { "X-Session-ID": sessionId } }).then((r) => r.data);

// Payments
export const startCheckout = () =>
  axios.post(`${API}/payments/checkout`, {}).then((r) => r.data);

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
